<div class="landing-page-wrapper" [class.dashboard-without-banner]="!bannersLoading && !businessList.length">
  <div class="slider-outer-block" id="first-section">
    <div class="navigation-wrapper">
      <div [ngClass]="{'d-none':!businessList?.length}" class="keen-slider keen-slider--vertical" #sliderRef>
        <app-dashboard-slider *ngFor="let business of businessList; let i=index; trackBy: trackByEntityId" [slideNumber]="i+1"
                              [imageSrc]="business.photo" [title]="business.restaurantName"
                              [info]="[business.cuisineName,business.typeName].join(' ')"
                              [resturantId]="business.id" [imgMetaData]="business.memberShipImageConfigurationList"></app-dashboard-slider>
      </div>
      <div *ngIf="bannersLoading && !businessList?.length" style="background-color: transparent;box-shadow: none;border: 0;"
           class="slider-skeleton">
        <div class="item">
          <div class="d-flex" style="height: 100%;">
            <div style="width: 100%;">
              <ngx-skeleton-loader [theme]="{height: '100%'}" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dots">
      <button (click)="slider.moveToIdx(i)" *ngFor="let slide of dotHelper; let i = index"
              [class]="'dot ' + (i === currentSlide ? 'active' : '')"></button>
    </div>
  </div>

  <section class="food-landing-cnt-section" id="second-section">
    <div class="container landing-container">
      <div class="row flex-grow-1">
        <div class="col-lg-auto order-1 order-lg-0 food-block-row">
          <span class="food-spacing-block"></span>
          <div class="aside-col-wrap content-sidebar" [class.feed-transitioning]="leavingSection">
            <div class="food-news sidebar-section" *ngIf="contentFocus !== 'news'"
                 [class.section-leaving]="leavingSection === 'news'" [class.section-entering]="enteringSection === 'news'">
              <h4 class="block-title food-news-block-title">
                Foodie News
                <button type="button" class="section-expand" aria-label="Expand Foodie News" title="Expand Foodie News"
                        aria-controls="dashboard-main-content" (click)="focusContent('news')">
                  <ng-container *ngTemplateOutlet="expandSectionIcon"></ng-container>
                </button>
              </h4>
              <ul class="food-news-ul scrollbar-list" *ngIf="newsLoading && !foodieNews?.length">
                <div style="background-color: transparent;box-shadow: none;border: 0">
                  <div style="margin-bottom: 24px" class="item" *ngFor="let i of loaderItems">
                    <div class="d-flex" style="gap: 16px;">
                      <div style="width: 20%;">
                        <ngx-skeleton-loader [theme]="{height: '45px', borderRadius: '10px'}" />
                      </div>
                      <div style="width: 80%;">
                        <ngx-skeleton-loader [theme]="{height: '16px', width:'80%'}" />
                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                        <div style="width: 30%;">
                          <ngx-skeleton-loader [theme]="{height: '16px'}" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ul>
              <ul [ngClass]="{'d-none':!foodieNews?.length}" class="food-news-ul scrollbar-list" (scroll)="hideSearchBar()"
                  (touchmove)="hideSearchBar()">
                <li #newslistItem id="{{i}}" *ngFor="let news of foodieNews; let i=index; trackBy: trackByEntityId"
                    [@fadeIn]="news.isVisible ? 'visible' : 'hidden'">
                  <app-food-news [imageSrc]="news.image" [popupImageSrc]="news.popupImage" [date]="news.createdOn | date:'MMM d, h:mm a'" [buttons]="news.tagList"
                                 [newsText]="news.name" [newsInfo]="news.description" [branchId]="news?.promotionBranchMappings?.[0]?.branchId" [restaurantDetails]="news.vendor">
                  </app-food-news>
                </li>
              </ul>
              <p class="section-empty" *ngIf="!newsLoading && !foodieNews.length">No foodie news yet.</p>
            </div>
            <!-- Articles takes the slot the expanded section left, and that slot's sizing classes with
                 it, so the sidebar keeps the same proportions at every breakpoint. -->
            <div class="compact-articles sidebar-section" *ngIf="contentFocus !== 'articles'"
                 [class.food-news]="contentFocus === 'news'" [class.deals-of-the-day]="contentFocus === 'deals'"
                 [class.section-leaving]="leavingSection === 'articles'" [class.section-entering]="enteringSection === 'articles'">
              <h4 class="block-title" [class.food-news-block-title]="contentFocus === 'news'"
                  [class.deals-of-the-day-block-title]="contentFocus === 'deals'">
                Articles
                <button type="button" class="section-expand" aria-label="Expand Articles" title="Expand Articles"
                        aria-controls="dashboard-main-content" (click)="focusContent('articles')">
                  <ng-container *ngTemplateOutlet="expandSectionIcon"></ng-container>
                </button>
              </h4>
              <div class="compact-article-list scrollbar-list" infinite-scroll [scrollWindow]="false"
                   [class.food-news-ul]="contentFocus === 'news'" [class.deals-of-the-day-ul]="contentFocus === 'deals'"
                   [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle" (scrolled)="onScrollDown()">
                <app-dashboard-article-card *ngFor="let article of articleList; trackBy: trackByEntityId"
                                            [article]="article" [compact]="true" (click)="articlePreview(article.id)">
                </app-dashboard-article-card>
                <p class="section-empty" *ngIf="!articleList.length && !isfetchingData">No articles found.</p>
                <ngx-skeleton-loader *ngIf="isfetchingData" [theme]="{height: '60px', borderRadius: '10px'}" />
              </div>
            </div>
            <div class="deals-of-the-day sidebar-section" *ngIf="contentFocus !== 'deals'"
                 [class.section-leaving]="leavingSection === 'deals'" [class.section-entering]="enteringSection === 'deals'">
              <h4 class="block-title deals-of-the-day-block-title">
                Deals and Offers <span class="day-text">Today</span>
                <button type="button" class="section-expand" aria-label="Expand Deals and Offers" title="Expand Deals and Offers"
                        aria-controls="dashboard-main-content" (click)="focusContent('deals')">
                  <ng-container *ngTemplateOutlet="expandSectionIcon"></ng-container>
                </button>
              </h4>
              <ul class="deals-of-the-day-ul scrollbar-list" *ngIf="dealsLoading && !foodieDealsOffers.length">
                <div style="background-color: transparent;box-shadow: none;border: 0">
                  <div style="margin-bottom: 24px" class="item" *ngFor="let i of loaderItems">
                    <div class="d-flex" style="gap: 16px;">
                      <div style="width: 20%;">
                        <ngx-skeleton-loader [theme]="{height: '45px', borderRadius: '10px'}" />
                      </div>
                      <div style="width: 80%;">
                        <ngx-skeleton-loader [theme]="{height: '16px', width:'80%'}" />
                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                        <div style="width: 30%;">
                          <ngx-skeleton-loader [theme]="{height: '16px'}" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ul>
              <ul [ngClass]="{'d-none':!foodieDealsOffers?.length}" class="deals-of-the-day-ul scrollbar-list" (scroll)="hideSearchBar()"
                  (touchmove)="hideSearchBar()">
                <li #dealsListItems id="{{i}}" [ngClass]="item.offerType.toLowerCase()"
                    *ngFor="let item of foodieDealsOffers; let i=index; trackBy: trackByEntityId" [@fadeIn]="item.isVisible ? 'visible' : 'hidden'">
                  <app-deals-offer style="display: flex;" [type]="item.offerType.toLowerCase()" [dealText]="item.name" [timeTo]="item.timeTo | date:'h:mm a'"
                                   [branchId]="item?.promotionBranchMappings?.[0]?.branchId" [dealData]="item" [indexOfDeal]="i"
                                   [dealInfo]="item.description" [date]="item.dateFrom | date:'MMM d, y'" [dateTo]="item.dateTo | date:'MMM d, y'" [timeFrom]="item.timeFrom | date:'h:mm a'">
                  </app-deals-offer>
                </li>
              </ul>
              <p class="section-empty" *ngIf="!dealsLoading && !foodieDealsOffers.length">No deals available right now.</p>
            </div>
          </div>
        </div>

        <div class="col-lg order-0 order-lg-1">
          <div class="cards-showcase-wrap" id="dashboard-main-content" #mainContent tabindex="-1" role="region"
               [class.main-leaving]="mainLeaving"
               [attr.aria-label]="contentFocus === 'articles' ? 'Articles' : focusedContentTitle">
            <div class="location-finder-wrap for-dashboard-only"
                 [ngClass]="{'article-filter-btn-visible':isContentFilterTab, 'from-mobile-app': isFromMobileApp}">

              <div class="search-wrap hungery-mobile-search-wrap" [class.d-none]="isFirstTime" [class.view-searchbar]="isSearchBarActive"
                   [class.has-qr-button]="shouldShowQRButton"
                   [class.mobile-location-editing]="isDashboardLocationSearchOpen && shouldUseMobileFilterBar"
                   [class.dashboard-location-expanded]="isDashboardLocationSearchOpen && !shouldUseMobileFilterBar && !isFromMobileApp"
                   [class.dashboard-location-opening]="isDashboardLocationOpening && !shouldUseMobileFilterBar && !isFromMobileApp"
                   [class.dashboard-location-closing]="isDashboardLocationClosing && !shouldUseMobileFilterBar && !isFromMobileApp">
                <div class="form-group">
                  <div *ngIf="!isContentFilterTab && !shouldUseMobileFilterBar && !isFromMobileApp" class="location-chip d-none d-md-flex dashboard-location-chip"
                       (click)="toggleDashboardLocationSearch($event)">
                    <ng-container *ngIf="!isDashboardLocationSearchOpen; else dashboardLocationEditor">
                      <img src="./assets/images/ic-location.svg" alt="Icon">
                      <h6 ngbTooltip="{{city}}">
                        {{ (city ? city : 'Location') }}
                      </h6>
                    </ng-container>
                    <ng-template #dashboardLocationEditor>
                      <img src="./assets/images/ic-location.svg" alt="Icon">
                      <app-location-search #dashboardDesktopLocationSearch
                                           (locationSelected)="onDashboardLocationSelected($event)"
                                           [isClear]="clearLocation"
                                           [selectedAddress]="city">
                      </app-location-search>
                    </ng-template>
                  </div>
                  <input class="form-control main-input" type="search" #dashboardSearchBar [(ngModel)]="searchText"
                         (ngModelChange)="onSearch($event)" placeholder="Search" aria-label="Search" (blur)="onBlur()" />
                  <div class="btn-grps top-layer">
                    <!-- preventDefault on mousedown keeps focus in the input: otherwise the blur
                         fires onBlur(), whose timer closes the whole bar before this click lands. -->
                    <button type="button" class="btn btn-clear-search" (click)="clearSearchBar()"
                            (mousedown)="$event.preventDefault()"
                            [ngClass]="{'d-none':isclearButtonShow}">
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.06698 0.183065C0.822892 -0.0610214 0.427151 -0.0610215 0.183065 0.183064C-0.0610214 0.42715 -0.0610215 0.822892 0.183064 1.06698L4.1163 5.00021L0.18349 8.93302C-0.0605962 9.17711 -0.0605961 9.57285 0.18349 9.81694C0.427576 10.061 0.823317 10.061 1.0674 9.81694L5.00015 5.88418L8.9329 9.81694C9.17699 10.061 9.57273 10.061 9.81682 9.81694C10.0609 9.57285 10.0609 9.17711 9.81682 8.93302L5.88359 4.99979L9.81639 1.06698C10.0605 0.822892 10.0605 0.42715 9.81639 0.183064C9.57231 -0.0610215 9.17657 -0.0610214 8.93248 0.183065L4.99973 4.11582L1.06698 0.183065Z"
                              fill="currentcolor" />
                      </svg>
                    </button>
                    <button *ngIf="shouldShowQRButton" class="btn btn-scan btn-view" id="scanBtn" [ngClass]="{'btn-clicked':isQRScanBtnClick}"
                            (click)="isQRScanBtnClick=!isQRScanBtnClick;QRScanClick()">
                      <div class="svg-wrap mod-svg-wrap">
                        <!-- <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                          style="margin-top: 0;">
                          <path
                            d="M0 9.33333V0H9.33333V9.33333H0ZM3.5 3.5V5.83333H5.83333V3.5H3.5ZM11.6667 9.33333V0H21V9.33333H11.6667ZM15.1667 3.5V5.83333H17.5V3.5H15.1667ZM0 11.6667V21H9.33333V11.6667H0ZM5.83333 15.1667V17.5H3.5V15.1667H5.83333ZM15.1667 11.6667H11.6667V14H15.1667V18.6667H14V16.3333H11.6667V21H16.3333V18.6667H18.6667V21H21V17.5H18.6667V16.3333H17.5V15.1667H21V11.6667H17.5V14H15.1667V11.6667Z"
                            fill="currentcolor" />
                        </svg> -->
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_1229_1454)">
                            <g clip-path="url(#clip1_1229_1454)">
                              <path d="M1.5 10.8333V1.5H10.8333V10.8333H1.5ZM5 5V7.33333H7.33333V5H5ZM13.1667 10.8333V1.5H22.5V10.8333H13.1667ZM16.6667 5V7.33333H19V5H16.6667ZM1.5 13.1667V22.5H10.8333V13.1667H1.5ZM7.33333 16.6667V19H5V16.6667H7.33333ZM16.6667 13.1667H13.1667V15.5H16.6667V20.1667H15.5V17.8333H13.1667V22.5H17.8333V20.1667H20.1667V22.5H22.5V19H20.1667V17.8333H19V16.6667H22.5V13.1667H19V15.5H16.6667V13.1667Z" fill="currentColor" />
                            </g>
                          </g>
                          <defs>
                            <clipPath id="clip0_1229_1454">
                              <rect width="21" height="21" fill="white" transform="translate(1.5 1.5)" />
                            </clipPath>
                            <clipPath id="clip1_1229_1454">
                              <rect width="21" height="21" fill="white" transform="translate(1.5 1.5)" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                    </button>
                    <button *ngIf="!isContentFilterTab && !isFromMobileApp" class="btn btn-view-text d-none d-md-flex" title="Open"
                            (click)="showOpenResturant()">
                      Open
                    </button>
                    <button *ngIf="!isContentFilterTab && !isFromMobileApp" class="btn btn-view-text d-none d-md-flex" title="Closeby"
                            (click)="showCloseResturant()">
                      Closeby
                    </button>
                    <button *ngIf="isContentFilterTab" class="btn btn-view-text d-none d-md-flex" title="Restaurant" [ngClass]="{'btn-clicked':isRestaurantSelected}"
                            (click)="onRestaurantClick()">
                      Restaurant
                    </button>
                    <div class="resto-button" [ngClass]="searchText != '' ? 'p-absolute-search':'p-absolute'" [class.d-none]="!isSearchBarActive">
                      <div class="cta-btn-wrap" [ngClass]="{'d-none':!isContentFilterTab || !shouldUseMobileFilterBar}">
                        <button class="btn btn-outline-primary" [ngClass]="{'btn-clicked-mobile': isRestaurantSelected}" (click)="onRestaurantClick()">
                          Restaurant
                        </button>
                      </div>
                    </div>
                    <div class="filter-dropdown chips-position" [class.d-none]="myDrop.isOpen()">
                      <div *ngIf="displayFilterChips?.length" class="filter-chips-wrap d-md-none">
                        <div class="chips-inner">
                          <div class="chip" *ngFor="let chips of displayFilterChips">
                            <span>{{chips.name}}</span>
                            <button (click)="removeChips(chips)" class="btn btn-chips">
                              <img src="./assets/images/ic-close.svg" alt="Icon">
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div ngbDropdown placement="bottom-end" [autoClose]="'outside'" #myDrop="ngbDropdown" class="f-drop-wrap"
                         (openChange)="onDashboardFilterDropdownOpenChange($event)">
                      <button class="btn btn-filter btn-view" [ngClass]="{'btn-clicked':isFilterBtnClick}" (shown)="onDropdownShown()"
                              (click)="isFilterBtnClick=!isFilterBtnClick;showFilterTab(articleFilterTabType.DetailsTab,true);onDropdownShown();"
                              id="dropdown-filter" ngbDropdownToggle #dropdownToggle>
                        <div class="svg-wrap mod-svg-wrap">
                          <!-- <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M1.05485 2.10499C0.828945 2.10499 0.603042 2.18919 0.420168 2.32601C-0.0531511 2.68386 -0.139209 3.34693 0.226538 3.7995V3.81003L5.93864 10.967V17.2714L8.40206 19.6921C8.82159 20.1026 9.51005 20.1026 9.92959 19.6921C10.3491 19.2817 10.3491 18.6081 9.92959 18.1976L8.0901 16.4084V10.2408L1.92619 2.51546C1.8232 2.38586 1.69094 2.28136 1.53977 2.21014C1.38859 2.13893 1.22262 2.10293 1.05485 2.10499ZM14.5445 9.47244V17.7661C14.5875 18.0818 14.4799 18.4186 14.2325 18.6397C14.133 18.7372 14.0148 18.8146 13.8846 18.8674C13.7545 18.9203 13.615 18.9474 13.4741 18.9474C13.3332 18.9474 13.1937 18.9203 13.0636 18.8674C12.9334 18.8146 12.8152 18.7372 12.7157 18.6397L10.5535 16.5241C10.4362 16.4119 10.347 16.2747 10.2929 16.1231C10.2387 15.9716 10.2212 15.8099 10.2415 15.6506V9.47244H10.2093L4.01309 1.70504C3.8384 1.48563 3.75958 1.20748 3.79385 0.931383C3.82811 0.655284 3.97268 0.40368 4.19597 0.231549C4.40036 0.0841995 4.62626 0 4.86292 0H19.9231C20.1597 0 20.3856 0.0841995 20.59 0.231549C20.8133 0.40368 20.9579 0.655284 20.9922 0.931383C21.0264 1.20748 20.9476 1.48563 20.7729 1.70504L14.5767 9.47244H14.5445Z"
                              fill="currentcolor" />
                            <circle cx="17" cy="17" r="6" fill="#FAF8FA" />
                            <path d="M13 16H16V13H18V16H21V18H18V21H16V18H13V16Z" fill="#AE77A0" />
                          </svg> -->
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_1229_1455)">
                              <g clip-path="url(#clip1_1229_1455)">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.92017 3.82601C2.10304 3.68919 2.32894 3.60499 2.55485 3.60499C2.72262 3.60293 2.88859 3.63893 3.03977 3.71014C3.19094 3.78136 3.3232 3.88586 3.42619 4.01546L9.5901 11.7408V17.9084L11.4296 19.6976C11.8491 20.1081 11.8491 20.7817 11.4296 21.1921C11.01 21.6026 10.3216 21.6026 9.90206 21.1921L7.43864 18.7714V12.467L1.72654 5.31003V5.2995C1.36079 4.84693 1.44685 4.18386 1.92017 3.82601ZM16.0445 13.0238V10.9724H16.0767L22.2729 3.20504C22.4476 2.98563 22.5264 2.70748 22.4922 2.43138C22.4579 2.15528 22.3133 1.90368 22.09 1.73155C21.8856 1.5842 21.6597 1.5 21.4231 1.5H6.36292C6.12626 1.5 5.90036 1.5842 5.69597 1.73155C5.47268 1.90368 5.32811 2.15528 5.29385 2.43138C5.25958 2.70748 5.3384 2.98563 5.51309 3.20504L11.7093 10.9724H11.7415V17.1506C11.7212 17.3099 11.7387 17.4716 11.7929 17.6231C11.847 17.7747 11.9362 17.9119 12.0535 18.0241L12.5001 18.4611C12.5155 16.0388 13.9662 13.9572 16.0445 13.0238Z" fill="currentcolor" />
                                <path d="M14.5 17.5H17.5V14.5H19.5V17.5H22.5V19.5H19.5V22.5H17.5V19.5H14.5V17.5Z" fill="currentcolor" />
                              </g>
                            </g>
                            <defs>
                              <clipPath id="clip0_1229_1455">
                                <rect width="21" height="21" fill="white" transform="translate(1.5 1.5)" />
                              </clipPath>
                              <clipPath id="clip1_1229_1455">
                                <rect width="23" height="23" fill="white" transform="translate(1.5 1.5)" />
                              </clipPath>
                            </defs>
                          </svg>

                        </div>
                      </button>

                      <!-- latest 2 filter -->
                      <div ngbDropdownMenu aria-labelledby="dropdown-filter" class="filter-dropdown" #filterDropdownMenu
                           [class.mobile-location-editing]="isDashboardLocationSearchOpen && shouldUseMobileFilterBar"
                           (click)="$event.stopPropagation()"
                           (touchstart)="$event.stopPropagation()"
                           (touchmove)="preventScrollClose($event)" (wheel)="preventScrollClose($event)">
                        <!-- <div *ngIf="displayFilterChips?.length" class="filter-chips-wrap d-none d-md-flex">
                          <div class="chips-inner">
                            <div class="chip" *ngFor="let chip of displayFilterChips">
                              <span>{{chip.name}}</span>
                              <button (click)="removeChips(chip)" class="btn btn-chips">
                                <img src="./assets/images/ic-close.svg" alt="Icon">
                              </button>
                            </div>
                          </div>
                        </div> -->
                        <div class="tab-wrapper">
                          <div ngbNav #nav="ngbNav" [(activeId)]="active" (activeIdChange)="onFilterTabChange($event)"
                               class="nav-pills outer-tabs">
                            <ng-container ngbNavItem="place">
                              <button ngbNavLink>Place</button>

                              <ng-template ngbNavContent>
                                <div class="inner-tab-block">
                                  <div ngbNav #nav="ngbNav" [(activeId)]="activeInner" class="nav-tabs">
                                    <!-- The listing API declares @FilterByRating but never applies
                                         it. The tab stays visible and announces itself; its id is
                                         not "1" so the panel still opens on Price Range. -->
                                    <ng-container ngbNavItem="rating">
                                      <button ngbNavLink ngbTooltip="Coming soon" tooltipClass="tooltip-custom">
                                        <img src="./assets/images/ic-tab-arrow.svg" alt="Icon" />
                                        By Rating
                                      </button>
                                      <ng-template ngbNavContent>
                                        <p class="text-center">Rating filters are coming soon.</p>
                                      </ng-template>
                                    </ng-container>
                                    <ng-container ngbNavItem="1">
                                      <button ngbNavLink>
                                        <img src="./assets/images/ic-tab-arrow.svg" alt="Icon" />
                                        Price Range
                                      </button>
                                      <ng-template ngbNavContent>
                                        <div class="checkbox-wrap-row">
                                          <div class="row">
                                            <div class="col-12" *ngFor="let price of priceRanges;let i = index;">
                                              <div class="form-check">
                                                <input type="checkbox" [(ngModel)]="selectedPrices[i]"
                                                       (ngModelChange)="onListingFilterChange($event);addToChip($event,price,false,articleFilterTabType.PriceRangeTab)"
                                                       class="form-check-input" [id]="'pricerange-'+i" />
                                                <label class="form-check-label" [for]="'pricerange-'+i">
                                                  {{price?.title}}
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </ng-template>
                                    </ng-container>
                                    <ng-container ngbNavItem="2">
                                      <button ngbNavLink>
                                        <img src="./assets/images/ic-tab-arrow.svg" alt="Icon" />
                                        Type of Meal
                                      </button>
                                      <ng-template ngbNavContent>
                                        <div class="checkbox-wrap-row">
                                          <div class="row">
                                            <div class="col-12" *ngFor="let meal of typeOfMeals;let i= index">
                                              <div class="form-check">
                                                <input type="checkbox" [(ngModel)]="selectedTypeOfMeals[i]"
                                                       (ngModelChange)="onListingFilterChange($event);addToChip($event,meal,false,articleFilterTabType.TypeOfMealTab)"
                                                       class="form-check-input" [id]="'meal-'+i" />
                                                <label class="form-check-label" [for]="'meal-'+i">
                                                  {{meal?.title}}
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </ng-template>
                                    </ng-container>
                                  </div>

                                  <div [ngbNavOutlet]="nav"></div>
                                </div>
                              </ng-template>
                            </ng-container>
                            <ng-container ngbNavItem="categories">
                              <button ngbNavLink>Categories</button>
                              <ng-template ngbNavContent>
                                <div class="inner-tab-block">
                                  <div ngbNav #nav="ngbNav" [(activeId)]="activeInner" class="nav-tabs">
                                    <ng-container ngbNavItem="1">
                                      <button ngbNavLink class="dashboard-categories-filter-btn">
                                        <img src="./assets/images/ic-tab-arrow.svg" alt="Icon" />
                                        Type Of Category
                                      </button>
                                      <ng-template ngbNavContent>
                                        <div class="checkbox-wrap-row dropdown-scroll-wrapper">
                                          <div class="row">
                                            <div class="col-12" *ngFor="let category of categories;let i=index">
                                              <div class="form-check">
                                                <input type="checkbox" [(ngModel)]="selectedCategories[i]"
                                                       (ngModelChange)="onListingFilterChange($event);addToChip($event,category,false,articleFilterTabType.CategoryTab)"
                                                       class="form-check-input" [id]="'category-'+i" />
                                                <label class="form-check-label" [for]="'category-'+i">
                                                  {{category?.title}}
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </ng-template>
                                    </ng-container>
                                  </div>

                                  <div [ngbNavOutlet]="nav"></div>
                                </div>
                              </ng-template>
                            </ng-container>
                            <!-- On phones the tabs wrap: keep the three content tabs together on their own row. -->
                            <span class="content-tabs-break" aria-hidden="true"></span>
                            <ng-container ngbNavItem="articles">
                              <button class="article-d-link" (click)="showFilterTab(articleFilterTabType.DetailsTab,true)"
                                      ngbNavLink style="
                            margin-left: auto; margin-right: 0;">
                                Articles
                              </button>
                              <ng-template ngbNavContent>
                                <ng-container *ngTemplateOutlet="contentFilterPanel"></ng-container>
                              </ng-template>
                            </ng-container>
                            <ng-container ngbNavItem="news">
                              <button class="content-d-link" (click)="showFilterTab(articleFilterTabType.DetailsTab,true)" ngbNavLink>
                                Foodie News
                              </button>
                              <ng-template ngbNavContent>
                                <ng-container *ngTemplateOutlet="contentFilterPanel"></ng-container>
                              </ng-template>
                            </ng-container>
                            <ng-container ngbNavItem="deals">
                              <button class="content-d-link" (click)="showFilterTab(articleFilterTabType.DetailsTab,true)" ngbNavLink>
                                Deals
                              </button>
                              <ng-template ngbNavContent>
                                <ng-container *ngTemplateOutlet="contentFilterPanel"></ng-container>
                              </ng-template>
                            </ng-container>
                          </div>
                          <div [ngbNavOutlet]="nav" class="outer-tab-content"></div>
                        </div>
                        <div *ngIf="displayFilterChips?.length" class="filter-chips-wrap d-md-none">
                          <div class="chips-inner">
                            <div class="chip" *ngFor="let chips of displayFilterChips">
                              <span>{{chips.name}}</span>
                              <button (click)="removeChips(chips)" class="btn btn-chips">
                                <img src="./assets/images/ic-close.svg" alt="Icon">
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="cta-btn-wrap"
                             [class.location-editor-open]="isDashboardLocationSearchOpen"
                             [ngClass]="{'d-none':isContentFilterTab || !shouldUseMobileFilterBar}">
                          <button type="button"
                                  class="btn btn-outline-primary with-icon mobile-location-trigger"
                                  [class.d-none]="isDashboardLocationSearchOpen && shouldUseMobileFilterBar"
                                  [title]="mobileLocationLabel"
                                  (touchstart)="openDashboardLocationSearch($event)"
                                  (click)="openDashboardLocationSearch($event)">
                            <div class="svg-wrap">
                              <img src="./assets/images/ic-location.svg" alt="Icon">
                            </div>
                            <span class="location-trigger-label">{{ mobileLocationLabel }}</span>
                            <span *ngIf="hasMobileLocationSelection"
                                  class="mobile-location-clear"
                                  role="button"
                                  aria-label="Clear location"
                                  (touchstart)="clearDashboardLocation($event)"
                                  (click)="clearDashboardLocation($event)">
                              &times;
                            </span>
                          </button>
                          <ng-container *ngTemplateOutlet="dashboardOpenClosePills"></ng-container>
                          <!-- <button class="btn btn-outline-primary with-icon" disabled>
                            <div class="svg-wrap">
                              <svg width="13" height="13" viewBox="0 0 13 13" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M0 5.77778V0H5.77778V5.77778H0ZM2.16667 2.16667V3.61111H3.61111V2.16667H2.16667ZM7.22222 5.77778V0H13V5.77778H7.22222ZM9.38889 2.16667V3.61111H10.8333V2.16667H9.38889ZM0 7.22222V13H5.77778V7.22222H0ZM3.61111 9.38889V10.8333H2.16667V9.38889H3.61111ZM9.38889 7.22222H7.22222V8.66667H9.38889V11.5556H8.66667V10.1111H7.22222V13H10.1111V11.5556H11.5556V13H13V10.8333H11.5556V10.1111H10.8333V9.38889H13V7.22222H10.8333V8.66667H9.38889V7.22222Z"
                                  fill="currentcolor" />
                              </svg>
                            </div>
                            Scan
                          </button>  -->
                        </div>
                      </div>

                    </div>
                    <!-- Open/Closeby live in three places (filter panel, beside the open location
                         field, and the active-filter row), so they are declared once here. -->
                    <ng-template #dashboardOpenClosePills>
                      <button class="btn btn-outline-primary" (click)="showOpenResturant()">Open</button>
                      <button class="btn btn-outline-primary" (click)="showCloseResturant()">
                        Closeby
                      </button>
                    </ng-template>
                    <!-- Mobile: the location field expands over the pill row and rides the keyboard.
                         It lives OUTSIDE the filter dropdown so hiding that modal cannot hide it. -->
                    <app-mobile-location-dock #dashboardMobileLocationDock
                                              [open]="isDashboardLocationSearchOpen && shouldUseMobileFilterBar"
                                              [originRect]="mobileLocationOriginRect"
                                              [isClear]="clearLocation"
                                              [selectedAddress]="selectedLocation?.address || null"
                                              (locationSelected)="onDashboardLocationSelected($event)">
                      <ng-container *ngTemplateOutlet="dashboardOpenClosePills"></ng-container>
                    </app-mobile-location-dock>
                    <!-- Active filters stay on screen with the panel closed, so they can be removed
                         without reopening it. -->
                    <div class="mobile-active-filters"
                         *ngIf="shouldUseMobileFilterBar && hasMobileLocationSelection
                                && !isDashboardLocationSearchOpen && !myDrop.isOpen()">
                      <button type="button"
                              class="btn btn-outline-primary with-icon mobile-location-trigger"
                              [title]="mobileLocationLabel"
                              (touchstart)="openDashboardLocationSearch($event)"
                              (click)="openDashboardLocationSearch($event)">
                        <div class="svg-wrap">
                          <img src="./assets/images/ic-location.svg" alt="Icon">
                        </div>
                        <span class="location-trigger-label">{{ mobileLocationLabel }}</span>
                        <span class="mobile-location-clear"
                              role="button"
                              aria-label="Remove location filter"
                              (touchstart)="removeDashboardLocationFilter($event)"
                              (click)="removeDashboardLocationFilter($event)">
                          <!-- SVG rather than &times;: that glyph sits off its box's centre and
                               ignores the box size. currentColor flips it to white on hover. -->
                          <svg width="13" height="13" viewBox="0 0 12 12" aria-hidden="true" focusable="false">
                            <path d="M2.6 2.6 L9.4 9.4 M9.4 2.6 L2.6 9.4" stroke="currentColor"
                                  stroke-width="1.9" stroke-linecap="round" />
                          </svg>
                        </span>
                      </button>
                    </div>
                    <button class="btn btn-view btn-search"
                            [ngClass]="{'typing': searchText,'btn-clicked':isSearchBtnClick}"
                            (click)="isSearchBtnClick=!isSearchBtnClick;viewSearchBar($event);myDrop.close();collapseDashboardLocationSearch()">
                      <div class="svg-wrap">
                        <!-- <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M13 13L10.1667 10.1617L13 13ZM11.7368 6.36842C11.7368 7.79221 11.1712 9.15769 10.1645 10.1645C9.15769 11.1712 7.79221 11.7368 6.36842 11.7368C4.94463 11.7368 3.57915 11.1712 2.57237 10.1645C1.5656 9.15769 1 7.79221 1 6.36842C1 4.94463 1.5656 3.57915 2.57237 2.57237C3.57915 1.5656 4.94463 1 6.36842 1C7.79221 1 9.15769 1.5656 10.1645 2.57237C11.1712 3.57915 11.7368 4.94463 11.7368 6.36842V6.36842Z"
                            stroke="currentcolor" stroke-width="2" stroke-linecap="round" />
                        </svg> -->
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_1229_1466)">
                            <path d="M21.5 21.5L17.014 17.006M19.5 11C19.5 13.2543 18.6045 15.4163 17.0104 17.0104C15.4163 18.6045 13.2543 19.5 11 19.5C8.74566 19.5 6.58365 18.6045 4.98959 17.0104C3.39553 15.4163 2.5 13.2543 2.5 11C2.5 8.74566 3.39553 6.58365 4.98959 4.98959C6.58365 3.39553 8.74566 2.5 11 2.5C13.2543 2.5 15.4163 3.39553 17.0104 4.98959C18.6045 6.58365 19.5 8.74566 19.5 11Z" stroke="currentcolor" stroke-width="2" stroke-linecap="round" />
                          </g>
                          <defs>
                            <clipPath id="clip0_1229_1466">
                              <rect width="21" height="21" fill="white" transform="translate(1.5 1.5)" />
                            </clipPath>
                          </defs>
                        </svg>

                      </div>
                    </button>
                    <button #dummyButton class="dummy-btn" style="position: absolute; top: -1000px;">Hidden Focus</button>
                  </div>
                  <div *ngIf="displayFilterChips?.length" class="filter-chips-wrap filter-chips-wrap-cst d-none d-md-flex">
                    <div class="chips-inner">
                      <div class="chip" *ngFor="let chip of displayFilterChips">
                        <span *ngIf="chip.name">{{chip.name}}</span>
                        <button (click)="removeChips(chip)" class="btn btn-chips">
                          <img src="./assets/images/ic-close.svg" alt="Icon">
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <section *ngIf="contentFocus !== 'articles'" class="focused-content" aria-labelledby="focused-content-title"
                     [class.content-entering]="mainEntering">
              <div class="focused-heading">
                <h2>
                  <span id="focused-content-title">{{ focusedContentTitle }}</span>
                  <button type="button" class="section-expand" [attr.aria-label]="'Collapse ' + focusedContentTitle"
                          [title]="'Collapse ' + focusedContentTitle" aria-controls="dashboard-main-content"
                          (click)="focusContent('articles')">
                    <ng-container *ngTemplateOutlet="collapseSectionIcon"></ng-container>
                  </button>
                </h2>
                <button type="button" class="btn btn-link" (click)="focusContent('articles')">Back to Articles</button>
              </div>
              <div class="focused-results" [attr.aria-busy]="focusedContent.loading">
                <div class="focused-grid" *ngIf="contentFocus === 'news'">
                  <app-food-news *ngFor="let news of focusedContent.rows; let i=index; trackBy: trackByEntityId" [focused]="true" [style.--stagger]="i"
                                 [imageSrc]="news.image" [popupImageSrc]="news.popupImage" [date]="news.createdOn | date:'MMM d, h:mm a'"
                                 [buttons]="news.tagList" [newsText]="news.name" [newsInfo]="news.description"
                                 [branchId]="news.promotionBranchMappings?.[0]?.branchId" [restaurantDetails]="news.vendor">
                  </app-food-news>
                </div>
                <div class="focused-grid" *ngIf="contentFocus === 'deals'">
                  <app-deals-offer *ngFor="let item of focusedContent.rows; let i=index; trackBy: trackByDealId" [focused]="true" [style.--stagger]="i"
                                   [type]="item.type == 1 ? 'deal' : 'offer'" [dealText]="item.name" [dealInfo]="item.description"
                                   [dealData]="item" [indexOfDeal]="i" [branchId]="item.promotionBranchMappings?.[0]?.branchId"
                                   [date]="item.dateFrom | date:'MMM d, y'" [dateTo]="item.dateTo | date:'MMM d, y'"
                                   [timeFrom]="item.timeFrom | date:'h:mm a'" [timeTo]="item.timeTo | date:'h:mm a'">
                  </app-deals-offer>
                </div>
                <div class="focused-grid" *ngIf="focusedContent.loading && !focusedContent.rows.length" aria-label="Loading results">
                  <ngx-skeleton-loader *ngFor="let item of loaderItems" [theme]="{height: '240px', borderRadius: '18px'}" />
                </div>
                <p *ngIf="!focusedContent.loading && !focusedContent.error && !focusedContent.rows.length" class="focused-empty" role="status">
                  {{ focusedHasCriteria ? (focusedContent.hasMore ? 'No matches yet. Load more to keep searching.' : 'No matches. Try another search or filter.') : 'Nothing to show just yet. Check back soon.' }}
                </p>
                <div *ngIf="focusedContent.error" class="focused-feedback" role="status">
                  <span>Couldn’t update {{ focusedContentTitle }}. Please try again.</span>
                  <button type="button" class="btn btn-outline-primary" (click)="retryFocusedContent()">Retry</button>
                </div>
                <button *ngIf="focusedContent.hasMore" type="button" class="btn btn-outline-primary content-load-more"
                        [disabled]="focusedContent.loading" (click)="loadMoreFocusedContent()">
                  {{ focusedContent.loading ? 'Loading…' : 'Load more' }}
                </button>
              </div>
            </section>
            <div class="article-dashboard-wrap position-relative" *ngIf="contentFocus === 'articles'"
                 [class.content-entering]="mainEntering">
              <div class="masonry-wrapper-outer" infinite-scroll [infiniteScrollDistance]="scrollDistance"
                   [infiniteScrollUpDistance]="scrollUpDistance" [scrollWindow]="false" [infiniteScrollThrottle]="throttle"
                   (scrolled)="onScrollDown()" (scroll)="hideSearchBar()" (touchmove)="hideSearchBar()">

                <div class="no-articles-found-wrap" *ngIf="articleList?.length === 0 && !isfetchingData">
                  <img src="./assets/images/no-articles-found.svg" alt="Icon">
                  <h3>No articles found</h3>
                  <p>
                    No articles found. Explore the latest in craft beer, artisanal cuisine, and culinary
                    trends in our flavorful journey
                    ahead!
                  </p>
                </div>
                <ngx-masonry #masonryWrapper [ordered]="true"
                             [options]="masonryOptions" class="masonry-wrapper">

                  <app-dashboard-article-card style="cursor: pointer;" (click)="articlePreview(article?.id)"
                                              *ngFor="let article of articleList;let i=index; trackBy: trackByEntityId" [showMutlipleImage]="true" [style.--stagger]="i"
                                              [article]="article"></app-dashboard-article-card>
                </ngx-masonry>

                <ngx-masonry *ngIf="articleList?.length === 0 && isfetchingData"
                             [options]="masonryOptionsForLoader" class="masonry-wrapper">
                  <div ngxMasonryItem class="masonry-item">
                    <div class="card hero-card" style="background-color: transparent;box-shadow: none;border: 0;">
                      <div class="item">
                        <div style="width: 40%;">
                          <ngx-skeleton-loader [theme]="{height: '16px'}" />
                        </div>
                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                        <div class="d-flex" style="gap: 10px;">
                          <div style="width: 50%;">
                            <ngx-skeleton-loader [theme]="{height: '82px', borderRadius: '10px'}" />
                          </div>
                          <div style="width: 50%;">
                            <ngx-skeleton-loader [theme]="{height: '82px', borderRadius: '10px'}" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div ngxMasonryItem class="masonry-item">
                    <div class="card hero-card" style="background-color: transparent;box-shadow: none;border: 0;">
                      <div class="item">
                        <div style="width: 70%;">
                          <ngx-skeleton-loader [theme]="{height: '16px'}" />
                        </div>
                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                        <div class="d-flex" style="gap: 10px;">
                          <div style="width: 33.3%;">
                            <ngx-skeleton-loader [theme]="{height: '58px', borderRadius: '10px'}" />
                          </div>
                          <div style="width: 33.3%;">
                            <ngx-skeleton-loader [theme]="{height: '58px', borderRadius: '10px'}" />
                          </div>
                          <div style="width: 33.3%;">
                            <ngx-skeleton-loader [theme]="{height: '58px', borderRadius: '10px'}" />
                          </div>
                        </div>
                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                      </div>
                    </div>
                  </div>
                  <div ngxMasonryItem class="masonry-item">
                    <div class="card hero-card" style="background-color: transparent;box-shadow: none;border: 0;">
                      <div class="item">
                        <div>
                          <ngx-skeleton-loader [theme]="{height: '170px', borderRadius: '10px'}" />
                        </div>
                        <div style="width: 70%;">
                          <ngx-skeleton-loader [theme]="{height: '16px'}" />
                        </div>
                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                      </div>
                    </div>
                  </div>
                  <div ngxMasonryItem class="masonry-item">
                    <div class="card hero-card" style="background-color: transparent;box-shadow: none;border: 0;">
                      <div class="item">
                        <div style="width: 70%;">
                          <ngx-skeleton-loader [theme]="{height: '16px'}" />
                        </div>
                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                        <div class="d-flex" style="gap: 10px;">
                          <div style="width: 33.3%;">
                            <ngx-skeleton-loader [theme]="{height: '58px', borderRadius: '10px'}" />
                          </div>
                          <div style="width: 33.3%;">
                            <ngx-skeleton-loader [theme]="{height: '58px', borderRadius: '10px'}" />
                          </div>
                          <div style="width: 33.3%;">
                            <ngx-skeleton-loader [theme]="{height: '58px', borderRadius: '10px'}" />
                          </div>
                        </div>
                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                      </div>
                    </div>
                  </div>
                  <div ngxMasonryItem class="masonry-item">
                    <div class="card hero-card" style="background-color: transparent;box-shadow: none;border: 0;">
                      <div class="item">
                        <div>
                          <ngx-skeleton-loader [theme]="{height: '170px', borderRadius: '10px'}" />
                        </div>
                        <div style="width: 70%;">
                          <ngx-skeleton-loader [theme]="{height: '16px'}" />
                        </div>
                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                      </div>
                    </div>
                  </div>
                  <div ngxMasonryItem class="masonry-item">
                    <div class="card hero-card" style="background-color: transparent;box-shadow: none;border: 0;">
                      <div class="item">
                        <div style="width: 40%;">
                          <ngx-skeleton-loader [theme]="{height: '16px'}" />
                        </div>
                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                        <ngx-skeleton-loader [theme]="{height: '16px'}" />
                        <div class="d-flex" style="gap: 10px;">
                          <div style="width: 50%;">
                            <ngx-skeleton-loader [theme]="{height: '82px', borderRadius: '10px'}" />
                          </div>
                          <div style="width: 50%;">
                            <ngx-skeleton-loader [theme]="{height: '82px', borderRadius: '10px'}" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ngx-masonry>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
</div>




<!-- Date / Category / Created By, for whichever content the panel is on (see filterMode). -->
<ng-template #contentFilterPanel>
  <div class="inner-tab-block">
    <div class="arti-tab-block"
         [ngClass]="{'datepicker-view-active':articleFilterOption.showDateFilter,'chips-visible':displayFilterChips?.length}">
      <div class="aside-block">
        <button class="btn btn-text" title="Date"
                (click)="showFilterTab(articleFilterTabType.DateFilterTab)">
          <img src="./assets/images/ic-tab-arrow.svg" alt="Icon" />
          Date
        </button>
        <button class="btn btn-text" title="Category"
                (click)="showFilterTab(articleFilterTabType.CategoryTab)">
          <img src="./assets/images/ic-tab-arrow.svg" alt="Icon" />
          Category
        </button>
        <button class="btn btn-text" title=" Created By"
                (click)="showFilterTab(articleFilterTabType.CreatedByTab)">
          <img src="./assets/images/ic-tab-arrow.svg" alt="Icon" />
          Created By
        </button>
      </div>
      <div class="arti-data-block"
           [ngClass]="{'d-none':!articleFilterOption.showfilterDetails}">
        <ul>
          <li class="date-li">
            <div (click)="clearDate()" class="date-form-block"
                 [ngClass]="{'d-none':!(fromDateControl.value && toDateControl.value && fromDateControl.value != toDateControl.value)}">
              <p>{{getFormattedDate(fromDateControl.value)}}</p>
              &nbsp;
              -
              &nbsp;
              <p>{{getFormattedDate(toDateControl.value)}}</p>
            </div>

            <div (click)="clearDate()" class="date-form-block"
                 [ngClass]="{'d-none':!(fromDateControl.value && toDateControl.value && fromDateControl.value == toDateControl.value)}">
              <p>{{getFormattedDate(fromDateControl.value)}}</p>
            </div>
          </li>
          <li class="category-li">
            <h5 (click)="clearCategory($event)">
              <div *ngIf="!displaySelectedType?.length">&nbsp;</div>
              <ng-container *ngFor="let category of displaySelectedType; let i = index">
                <ng-container *ngIf="i === 0">
                  <div>{{ category + '&nbsp;'}}</div>
                  <div [ngbTooltip]="hoursSlot" placement="top" tooltipClass="theme-tooltip"
                       container="body" *ngIf="displaySelectedType.length - 1 != 0">
                    +{{
                  (displaySelectedType.length - 1 > 1) ?
                  displaySelectedType.length
                  - 1 + ' more' : displaySelectedType.length - 1 + ' more'
                    }}
                  </div>
                </ng-container>
              </ng-container>
              <ng-template #hoursSlot>
                <p *ngFor="let item of displaySelectedType">
                  <span>{{ item }}</span>
                </p>
              </ng-template>
            </h5>
          </li>
          <li>
            <h5 (click)="clearCreatedBy($event)">
              <ng-container *ngFor="let people of displayselectedPeople; let i = index">
                <ng-container *ngIf="i === 0">
                  <div>{{ people + '&nbsp;'}}</div>
                  <div [ngbTooltip]="hoursSlot" placement="top" tooltipClass="theme-tooltip"
                       container="body" *ngIf="displayselectedPeople.length - 1 != 0">
                    +{{
                  (displayselectedPeople.length - 1 > 1) ?
                  displayselectedPeople.length
                  - 1 + ' more' : displayselectedPeople.length - 1 + ' more'
                    }}
                  </div>
                </ng-container>
              </ng-container>
              <ng-template #hoursSlot>
                <p *ngFor="let item of displayselectedPeople">
                  <span>{{ item }}</span>
                </p>
              </ng-template>
            </h5>
          </li>
        </ul>
      </div>
      <div class="date-picker-layer"
           [ngClass]="{'d-none':!articleFilterOption.showDateFilter}">
        <div class="datepicker-grp-base">

          <ngb-datepicker #dp [ngClass]="{'date-selected-init':toDate || fromDate }"
                          (dateSelect)="onDateSelection($event)" [displayMonths]="1" [dayTemplate]="t"
                          outsideDays="hidden" />
          <ng-template #t let-date let-focused="focused">
            <span class="custom-day btn-light" [class.focused]="focused"
                  [class.range]="isRange(date)"
                  [class.faded]="isHovered(date) || isInside(date)"
                  (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
              {{ date.day }}
            </span>
          </ng-template>

        </div>
      </div>
      <div #scrollBarContainer class="dropdown-scroll-wrapper">
        <ul class="category-ul-layer dropdown-scroll-wrapper"
            [ngClass]="{'d-none':!articleFilterOption.showCategoryFilter}">
          <li *ngFor="let type of types;let i = index;">
            <div class="form-check">
              <input class="form-check-input" [id]="'category-'+i" [(ngModel)]="typeSelect[i]"
                     (ngModelChange)="onFilterChange($event);addToChip($event,type,true,articleFilterTabType.CategoryTab)"
                     type="checkbox">
              <label class="form-check-label" [for]="'category-'+i">
                {{type?.name}}
              </label>
            </div>
          </li>
        </ul>
      </div>
      <div class="created-by-layer"
           [ngClass]="{'d-none':!articleFilterOption.showCreatedByFilter}">
        <div class="multi-select-wrap">
          <ng-select [placeholder]="filterMode === 'articles' ? 'Select User' : 'Select Restaurant'" [(ngModel)]="uploadedBy"
                     (ngModelChange)="onFilterChange($event);addToChip($event,$event,true,articleFilterTabType.CreatedByTab)"
                     class="ng-form-select primary-select">
            <ng-option *ngFor="let people of peoples"
                       [value]="people.id">{{people.name}}</ng-option>
          </ng-select>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #expandSectionIcon>
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M14 4h6v6M20 4l-7 7M10 20H4v-6M4 20l7-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</ng-template>

<ng-template #collapseSectionIcon>
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M4 14h6v6M3 21l7-7M20 10h-6V4M21 3l-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</ng-template>

<ng-template #viewArticleModal let-modal>
  <div class="modal-header">
    <button type="button" style="z-index: 30;" class="btn-close" aria-label="Close"
            (click)="modal.dismiss('Cross click')" title="Close Modal"></button>
  </div>
  <div class="modal-body">
    <app-article-preview [articleId]="selectedArticlId" [article]="selectedArticle" [isRedirectedForArticleApproval]="isRedirectedForArticleApproval"></app-article-preview>
  </div>
</ng-template>
